module.exports = __webpack_public_path__ + "static/media/up-arrow.23e84a48.svg";